import BulkAssignTripsPopover from './BulkAssignTripsPopover/BulkAssignTripsPopover';
import { RejectRequestedTripsButton } from './RejectRequestedTripsButton';
import { ShowApplyRouteTemplatesModalAction } from './RouteTemplates/ShowApplyRouteTemplatesModalAction';
import { UnassignedTripsGroupSelectionSection } from './UnassignedTripsGroupSelectionSection';
import { UnassignedTripsHeader } from './UnassignedTripsHeader';
import { UnassignedTripsListSection } from './UnassignedTripsListSection';
import { UnassignedTripsRunBambiRunSection } from './UnassignedTripsRunBambiRunSection';
import { UnassignTripsDropTarget } from './UnassignTripsDropTarget';
import { useSearchedUnassignedTripsFromDispatchResponse } from './useSearchedUnassignedTripsFromDispatchResponse';

export function UnassignedTrips() {
  const searchedUnassignedTrips =
    useSearchedUnassignedTripsFromDispatchResponse();

  return (
    <>
      <UnassignedTripsHeader />
      <UnassignTripsDropTarget>
        {searchedUnassignedTrips.length ? (
          <div className="flex items-start justify-between gap-1">
            <UnassignedTripsGroupSelectionSection
              searchedUnassignedTrips={searchedUnassignedTrips}
            />
            <div className="-mt-1.5">
              <ShowApplyRouteTemplatesModalAction />
              <BulkAssignTripsPopover />
              <RejectRequestedTripsButton />
            </div>
          </div>
        ) : null}
        <UnassignedTripsListSection
          searchedUnassignedTrips={searchedUnassignedTrips}
        />
      </UnassignTripsDropTarget>
      <UnassignedTripsRunBambiRunSection />
    </>
  );
}
